import React from "react";
import { Faq } from "../../compilers/faq";
import Accordion from "../singlecomponents/Accordion";

type FaqContainerProps = {
  faqs: Faq[];
};

const FaqContainer: React.FC<FaqContainerProps> = ({ faqs }) => {
  return (
    <div className="accordion" id="zefiFaq">
      {faqs.map((faq, index) => (
        <Accordion
          ExtraClass="zefiFaq"
          key={`faq-item-${faq.question.replaceAll(" ", "-").toLowerCase()}`}
          TitleHeader={faq.question}
          AccordionWrapper="zefiFaq"
          AccordionHeading={`zefiFaq-${index}`}
          AccordionCollapse={`zefiFaq-collapse-${index}`}
        >
          <p className="mt-2">{faq.answer}</p>
        </Accordion>
      ))}
    </div>
  );
};

export default FaqContainer;
